// extracted by mini-css-extract-plugin
module.exports = {"selectionType":"LocationAttributeRadioSelection_selectionType_2F1aZ"};